<template>
  <section class="home">
    <div class="container">
      <el-tabs v-model="activeName">
        <el-tab-pane
          :label="$t('pages.home.tab1')"
          name="first">
          <h3>{{$t('pages.home.tab1_title1')}}</h3>
          <p>{{$t('pages.home.tab1_par1')}}</p>
          <p>{{$t('pages.home.tab1_par2')}}</p>
          <p>{{$t('pages.home.tab1_par3')}}<a href="https://www.unige.ch/lettres/humanites-numeriques/" target="_blank">{{$t('pages.home.tab1_link0')}}</a>
          <p>{{$t('pages.home.tab1_par3a')}}<a href="http://www.agence-nationale-recherche.fr/" target="_blank">{{$t('pages.home.tab1_link1')}}</a>
          {{$t('pages.home.tab1_par4')}}<a href="http://www.ens.fr//" target="_blank">{{$t('pages.home.tab1_link2')}}</a>
          {{$t('pages.home.tab1_par5')}}<a href="https://www.univ-psl.fr/fr" target="_blank">{{$t('pages.home.tab1_link3')}}</a>
          {{$t('pages.home.tab1_par6')}}<a href="http://transfers.ens.fr//" target="_blank">{{$t('pages.home.tab1_link4')}}</a>
          {{$t('pages.home.tab1_par7')}}
          </p>
          <p>{{$t('pages.home.tab1_par8')}}
          </p>
          <h3>{{$t('pages.home.tab1_title2')}}</h3>
          <p><em>{{$t('pages.home.tab1_par9')}}</em></p>
        <p><strong>{{$t('pages.home.tab1_par10')}}</strong> Yann Leboulanger.
        <strong>{{$t('pages.home.tab1_par11')}}</strong> Makina Corpus.
        </p>
        </el-tab-pane>
        <el-tab-pane :label="$t('pages.home.tab2')" name="second">
        <h3>{{$t('pages.home.tab2_title1')}}</h3>
        <p>{{$t('pages.home.tab2_par1')}}
        <br/>{{$t('pages.home.tab2_par2')}}</p>
        <h3>{{$t('pages.home.tab2_title2')}}</h3>
        <p>{{$t('pages.home.tab2_par3')}}</p>
        <p>{{$t('pages.home.tab2_par4')}}</p>
        <p>{{$t('pages.home.tab2_par5')}}</p>
        </el-tab-pane>
        <el-tab-pane :label="$t('pages.home.tab3')" name="third">
        <h3>{{$t('pages.home.tab3_title1')}}</h3>
        <p>{{$t('pages.home.tab3_par1')}}
        <br/>{{$t('pages.home.tab3_par2')}}
        <br/><b>{{$t('pages.home.tab3_par3')}}</b></p>
        <h3>{{$t('pages.home.tab3_title2')}}</h3>
        <p>{{$t('pages.home.tab3_par4')}}</p>
        <p><strong>{{$t('pages.home.tab3_par5')}}</strong></p>
        <p>{{$t('pages.home.tab3_par6')}}</p>
        <p><strong>{{$t('pages.home.tab3_par7')}}</strong></p>
        <p>{{$t('pages.home.tab3_par8')}}</p>
        <p><br/><em>{{$t('pages.home.tab3_par9')}}</em></p>
        </el-tab-pane>
        <el-tab-pane :label="$t('pages.home.tab4')" name="fourth">
        <p>{{$t('pages.home.tab4_par1')}}</p>
        <h3>{{$t('pages.home.tab4_title1')}}</h3>
        <p>{{$t('pages.home.tab4_par2')}}</p>
        <h3>{{$t('pages.home.tab4_title2')}}</h3>
        <p>{{$t('pages.home.tab4_par3')}} <b>{{$t('pages.home.tab4_par4')}}</b> {{$t('pages.home.tab4_par5')}}</p>
        <h3>{{$t('pages.home.tab4_title3')}}</h3>
        <p>{{$t('pages.home.tab4_par6')}} <b>{{$t('pages.home.tab4_par7')}}</b></p>
        <ul>
         <li><strong>{{$t('pages.home.tab4_par8')}}</strong>{{$t('pages.home.tab4_par9')}}</li>
         <li><strong>{{$t('pages.home.tab4_par10')}}</strong>{{$t('pages.home.tab4_par11')}}</li>
         <li>{{$t('pages.home.tab4_par12')}}</li>
         <li><strong>{{$t('pages.home.tab4_par13')}}</strong>{{$t('pages.home.tab4_par14')}}</li>
        </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
  </section>
</template>

<script>
// import Vue from 'vue'
import {
  Tabs,
  TabPane
} from 'element-ui'
export default {
  name: 'home',
  data () {
    return {
      activeName: 'first'
    }
  },
  components: {
    elTabs: Tabs,
    elTabPane: TabPane
  }
}
</script>

<style scoped>

.container {
  max-width: 1024px;
  margin: 2em auto;
  padding: 1em;
  overflow: auto;
  background: white;
  font-size: .75rem;
  color: #1f2d3d;
}

a {
  color: #35C1D6;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue